// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 691 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"81":"52e30bfc438f18af5b77","175":"5265eaeb55a8edd11ee0","691":"f3266a07f1b3fe01f1f9","932":"0a48769623cba576281a"}[chunkId] + ".js";
};